import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/EpisodeGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Poster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/WatchlistButton.tsx");
